// @flow
export { default, Wrapper } from './FormGroup';
export type { CommonProps } from './FormGroup.types';



// WEBPACK FOOTER //
// ../react-lib/src/components/formFields/FormGroup/index.js